import LegalPage from "@/pages/legal/LegalPage";

const sections = [
  {
    heading: "1. Overview",
    body: [
      "This Privacy Policy explains how Fortunastrive Services Private Limited (\"Fortuna Strive\", \"we\", \"us\") collects, uses, and protects the information you provide when you interact with our website or submit an enquiry.",
      "By using this website or submitting the contact form, you consent to the practices described in this policy.",
    ],
  },
  {
    heading: "2. Information We Collect",
    body: ["We collect only the information you choose to provide through our contact form or by contacting us directly. This may include:"],
    list: [
      "Name and company name",
      "Work email address and phone number",
      "Website and business details you share",
      "The contents of your enquiry",
    ],
  },
  {
    heading: "3. How We Use Your Information",
    body: ["We use the information you provide to:"],
    list: [
      "Respond to your enquiry and communicate with you",
      "Understand your requirements and prepare relevant proposals",
      "Provide the services you request",
      "Maintain records of our communications",
    ],
  },
  {
    heading: "4. SMS and Communications Consent",
    body: [
      "We only send SMS or text communications where you have explicitly opted in via the optional SMS consent checkbox on our contact form. SMS consent is never a condition of purchase and is kept separate from your enquiry.",
      "You may opt out of SMS communications at any time by replying STOP, or reply HELP for assistance. Message frequency varies and message and data rates may apply.",
    ],
  },
  {
    heading: "5. Data Sharing",
    body: [
      "We do not sell your personal information. We may share information with trusted service providers strictly to operate our business and deliver requested services, subject to appropriate confidentiality obligations.",
    ],
  },
  {
    heading: "6. Data Retention & Security",
    body: [
      "We retain enquiry information only for as long as necessary to respond to and manage our relationship with you, and apply reasonable technical and organisational measures to protect it.",
    ],
  },
  {
    heading: "7. Your Rights",
    body: [
      "You may request access to, correction of, or deletion of the personal information we hold about you by contacting us at the email address below.",
    ],
  },
  {
    heading: "8. Cookies & Analytics",
    body: [
      "This website does not load third-party analytics or advertising trackers by default. If analytics are enabled in future, we will update this policy and, where legally required, request your consent before loading non-essential cookies.",
    ],
  },
  {
    heading: "9. Contact",
    body: ["For any privacy-related questions or requests, please contact us using the details below."],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testId="privacy-page"
      label="Legal"
      title="Privacy Policy"
      updated="January 2026"
      intro="How Fortuna Strive collects, uses, and protects the information you provide."
      sections={sections}
    />
  );
}
